/**
 * Parallax Class
 */
export class Parallax {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.scene = document.querySelector( containerEl );
		this.mq = window.matchMedia( '(min-width: 1200px)' );
		if ( ! this.scene ) {

			return false;

		}

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const parallax = document.querySelectorAll( '.fx-parallax' );

		// Scroll
		if ( parallax.length > 0 ) {

			window.addEventListener( 'scroll', () => {

				animate();

			} );

		}

		/**
		 * Animate
		 *
		 * @return {void}
		 */
		const animate = () => {

			if ( window.innerWidth < 993 ) {

				return;

			}
			const windowH = window.innerHeight;

			parallax.forEach( ( scene ) => {

				const ratio = scene.getAttribute( 'data-parallax' );
				const height = `${ ( 1 + ratio ) * 100 }%`;
				const distance = ( windowH - scene.clientHeight ) / ( ( 1 + ratio ) * 100 );

				const item = scene.querySelector( '.fx-parallax-item' );
				item.style.height = height;

				const sceneTop = scene.getBoundingClientRect().top;
				const sceneBottom = scene.getBoundingClientRect().top + scene.clientHeight;

				if ( sceneTop <= windowH && ( sceneTop + sceneBottom >= 0 ) ) {

					item.style.transform = `translate3d(0px,${ ( -sceneTop - distance ) * ratio / 2 }px, 0px)`;

				}

			} );

		}

		animate();

		const parallaxHero = document.querySelectorAll( '.fx-parallax-hero' );

		// Scroll
		if ( parallaxHero.length > 0 ) {

			window.addEventListener( 'scroll', () => {

				animateHero();

			} );

		}

		/**
		 * Animate Hero
		 *
		 * @return {void}
		 */
		const animateHero = () => {

			if ( window.innerWidth < 993 ) {

				return;

			}
			const windowY = window.pageYOffset || document.documentElement.scrollTop;
			const windowH = window.innerHeight;

			parallaxHero.forEach( ( scene ) => {

				const ratio = scene.getAttribute( 'data-parallax' );
				const height = `${ ( 1 + ratio ) * 100 }%`;

				const sceneY = scene.offsetTop - windowY;
				const distance = windowH / scene.clientHeight;

				const item = scene.querySelector( '.fx-parallax-item' );
				item.style.height = height;

				if ( sceneY <= windowH && sceneY >= -scene.clientHeight ) {

					item.style.transform = `translate3d(0px,${ -sceneY * ratio / distance }px, 0px)`;

				}

			} );

		}

		animateHero();

	}

}
